var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "sidecart-wrapper" },
    [
      _c("transition", { attrs: { name: "fade" } }, [
        _vm.shopTheLookOpen
          ? _c("div", {
              staticClass: "sidecart__overlay",
              on: {
                click: function($event) {
                  return _vm.$store.dispatch("shopTheLook/closeDrawer")
                }
              }
            })
          : _vm._e()
      ]),
      _c("transition", { attrs: { name: "off-canvas-right" } }, [
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.shopTheLookOpen,
                expression: "shopTheLookOpen"
              },
              {
                name: "scroll-lock",
                rawName: "v-scroll-lock",
                value: _vm.shopTheLookOpen && _vm.isNotMobile,
                expression: "shopTheLookOpen && isNotMobile"
              }
            ],
            staticClass: "sidecart"
          },
          [
            _c("div", { staticClass: "shop-the-look-drawer" }, [
              _c("div", { staticClass: "shop-the-look-drawer__header" }, [
                _c("p", { staticClass: "h2 shop-the-look-drawer__title" }, [
                  _vm._v("SHOP THE LOOK")
                ]),
                _c(
                  "button",
                  {
                    staticClass: "sidecart__close shop-the-look-drawer__close",
                    attrs: {
                      label: "Close shop the look",
                      "aria-label": "Close shop the look"
                    },
                    on: {
                      click: function($event) {
                        return _vm.$store.dispatch("shopTheLook/closeDrawer")
                      }
                    }
                  },
                  [_c("icon", { attrs: { name: "close", size: "24px" } })],
                  1
                )
              ]),
              _c(
                "div",
                { staticClass: "shop-the-look-drawer__scrolling-container" },
                [
                  _c(
                    "div",
                    { staticClass: "shop-the-look-drawer__main" },
                    _vm._l(_vm.shopTheLookTile.products, function(product) {
                      return _c(
                        "div",
                        {
                          key: product.handle,
                          staticClass: "shop-the-look-drawer__card"
                        },
                        [
                          _c(
                            "a",
                            {
                              staticClass:
                                "shop-the-look-drawer__product-image",
                              attrs: { href: product.url }
                            },
                            [
                              _c("img", {
                                staticClass:
                                  "shop-the-look-drawer__product-image-img",
                                attrs: { src: product.featuredImage }
                              })
                            ]
                          ),
                          _c(
                            "div",
                            {
                              staticClass:
                                "shop-the-look-drawer__product-details"
                            },
                            [
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "shop-the-look-drawer__product-vendor"
                                },
                                [_vm._v(_vm._s(product.vendor))]
                              ),
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "shop-the-look-drawer__product-title"
                                },
                                [_vm._v(_vm._s(product.title))]
                              ),
                              _vm.isCallForPrice(product)
                                ? _c(
                                    "p",
                                    {
                                      staticClass: "shop-the-look-drawer__price"
                                    },
                                    [_vm._v("Call For Price")]
                                  )
                                : _c(
                                    "div",
                                    {
                                      staticClass:
                                        "shop-the-look-drawer__price-container"
                                    },
                                    [
                                      product.price < product.compareAtPrice
                                        ? _c(
                                            "span",
                                            {
                                              staticClass:
                                                "shop-the-look-drawer__compare-price"
                                            },
                                            [
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "shop-the-look-drawer__price"
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      product.compareAtPrice
                                                    )
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                        : _vm._e(),
                                      _c(
                                        "span",
                                        {
                                          staticClass:
                                            "shop-the-look-drawer__price"
                                        },
                                        [_vm._v(_vm._s(product.price))]
                                      )
                                    ]
                                  ),
                              !_vm.isCallForPrice(product)
                                ? _c("toggle-atc", {
                                    attrs: { product: product }
                                  })
                                : _vm._e()
                            ],
                            1
                          )
                        ]
                      )
                    }),
                    0
                  ),
                  _c(
                    "div",
                    { staticClass: "shop-the-look-drawer__add-all-cart" },
                    [
                      !_vm.allItemIsInCart
                        ? _c(
                            "async-button",
                            {
                              staticClass:
                                "button button--primary shop-the-look-drawer__add-all-cart-button",
                              attrs: { promise: _vm.addToCartPromise },
                              on: { click: _vm.addAllToCart }
                            },
                            [
                              _vm._v(
                                "Add " +
                                  _vm._s(_vm.numberOfProductsInShopTheLook) +
                                  " Products to Bag"
                              )
                            ]
                          )
                        : _c(
                            "async-button",
                            {
                              staticClass:
                                "pdp__atc product-form__atc button--secondary toggle-atc__added shop-the-look-drawer__add-all-cart-button",
                              attrs: { disabled: "" }
                            },
                            [
                              _c("icon", {
                                attrs: { name: "check-black", size: "24" }
                              })
                            ],
                            1
                          )
                    ],
                    1
                  )
                ]
              )
            ])
          ]
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }